<template>
  <div class="content">
    <!-- your content here -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
